import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    padding: 0;
    margin: 0;
  }

  body {
    min-height: 100vh;
    background-color: #fafafa;
    padding-bottom: 180px;
  }
`;